const Style = {
    wrapper:
        'sticky top-0 z-50 border-b border-border bg-background/80 backdrop-blur-md',
    inner: 'mx-auto flex h-16 max-w-6xl items-center gap-8 px-6',

    // icon + wordmark. The mark is `w-auto` on purpose: /assets/icon.png is
    // ~1.4:1, so a square `w-*` would squash it.
    logo: 'flex items-center gap-2 text-lg font-bold tracking-[-0.01em] text-primary-600 no-underline',
    logoMark: 'h-7 w-auto shrink-0',

    nav: 'mr-auto hidden items-center gap-6 md:flex',
    link: 'text-sm text-text-secondary no-underline transition-colors duration-150 ease-out hover:text-primary-600',

    actions: 'ml-auto flex items-center gap-3',

    theme: `flex h-9 w-9 flex-none cursor-pointer items-center justify-center rounded-md
    border border-border bg-surface text-text-secondary transition-colors duration-150 ease-out
    hover:border-primary-400 hover:text-primary-600`,

    // EN / FR segmented control. Same chrome as `theme` so the two sit as a pair.
    lang: `flex h-9 flex-none items-center rounded-md border border-border bg-surface p-0.5`,
    langOption: `flex h-full cursor-pointer items-center rounded px-2.5 text-xs font-semibold
    tracking-wide text-text-secondary transition-colors duration-150 ease-out hover:text-primary-600`,
    langActive: 'bg-primary-50 text-primary-600 dark:bg-primary-900/40',

    signin: `hidden rounded-md border border-border bg-surface px-3.5 py-2 text-sm font-medium
    text-text-primary no-underline transition-colors duration-150 ease-out hover:border-primary-400 sm:inline-block`,

    cta: `inline-block rounded-md bg-primary-600 px-4 py-2.5 text-sm font-semibold text-white
    no-underline transition-colors duration-150 ease-out hover:bg-primary-700`,
};

export default Style;
